export const fieldTypes = {
    multiCheckbox: 'multi-checkbox',
    checkboxGroup: 'checkbox-group',
    autocomplete: 'autocomplete',
    text: 'text',
    select: 'select',
    dateRange: 'date-range',
    checkbox: 'checkbox',
    date: 'date',
    number: 'number',
    singleStateCheckboxField: 'single-state-checkbox-field',
    option: 'option',
    groupedCheckbox: 'grouped-checkbox',
};